import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, signInWithPhoneNumber, RecaptchaVerifier } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css'; // Import the CSS file for styling

const LoginPage = () => {
  const [identifier, setIdentifier] = useState(''); // State to handle email or phone number
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [errorMessage, setErrorMessage] = useState(''); // State to store error message
  const [isPhoneNumber, setIsPhoneNumber] = useState(false); // State to track if the identifier is a phone number
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      if (isPhoneNumber) {
        // Phone number login logic
        const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);
        const confirmationResult = await signInWithPhoneNumber(auth, identifier, recaptchaVerifier);
        const verificationCode = window.prompt('Please enter the verification code that was sent to your phone');
        await confirmationResult.confirm(verificationCode);
      } else {
        // Email login logic
        await signInWithEmailAndPassword(auth, identifier, password);
      }
      navigate('/members');
    } catch (error) {
      console.error("Error signing in:", error);
      switch (error.code) {
        case 'auth/user-not-found':
          setErrorMessage('No account found with this email.');
          break;
        case 'auth/wrong-password':
          setErrorMessage('Incorrect password. Please try again.');
          break;
        case 'auth/invalid-email':
          setErrorMessage('Invalid email format.');
          break;
        default:
          setErrorMessage('Login unsuccessful. Please check credentials or create an account.');
      }
    }
  };

  const handleIdentifierChange = (e) => {
    const value = e.target.value;
    setIdentifier(value);
    // Simple check to determine if the identifier is a phone number
    setIsPhoneNumber(/^\+?[1-9]\d{1,14}$/.test(value));
  };

  return (
    <div className="auth-shell auth-shell-login">
      <div className="auth-page-container auth-login-page-container">
        <h1>Existing K&M Customers Login Here!</h1>
        <h2 className='auth-subheading'>View Our Products, Place Orders, And More!</h2>
        <div className="auth-page auth-login-page">
          <div className="auth-card auth-login-card">
            <h2 className='auth-card-title'>Login</h2>
            {errorMessage && <p className="error-message">{errorMessage}</p>} {/* Display error message */}
            <form onSubmit={handleLogin}>
              <input
                type="text"
                placeholder="Email or Phone Number"
                value={identifier}
                onChange={handleIdentifierChange}
              />
              {!isPhoneNumber && (
                <>
                  <input
                    type={showPassword ? 'text' : 'password'} // Toggle between 'text' and 'password'
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="auth-show-password-container">
                    <input
                      type="checkbox"
                      id="show-password"
                      checked={showPassword}
                      onChange={() => setShowPassword(!showPassword)} // Toggle the state
                    />
                    <label htmlFor="show-password">Show Password</label>
                  </div>
                </>
              )}
              <button type="submit">Login</button>
              <p className='auth-alt-link'>Need To Create An Account? Sign Up <a href={`${process.env.PUBLIC_URL}/signup`}>Here!</a>.</p>
            </form>
            <button
              className="forgot-password-button auth-secondary-button"
              onClick={() => navigate('/forgot-password')}
            >
              Forgot Password?
            </button>
            <div id="recaptcha-container"></div> {/* Recaptcha container for phone number auth */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;